// ---------------------------------------------------------------------------
// Social Media Hub Academy — combined course (single source of truth).
// Sections are authored in three parts to keep files manageable.
// ---------------------------------------------------------------------------

import type { TrainingSection, TrainingSlide } from './trainingTypes';
import { SECTIONS_A } from './trainingSlidesA';
import { SECTIONS_B } from './trainingSlidesB';
import { SECTIONS_C } from './trainingSlidesC';

export const COURSE_SECTIONS: TrainingSection[] = [...SECTIONS_A, ...SECTIONS_B, ...SECTIONS_C];

/** Every content slide id in course order (intro slides are virtual, per-section). */
export interface FlatSlideRef {
  sectionIdx: number;
  slideIdx: number; // 0 = section intro (virtual), 1..n = content slides
  slideId: string;
  section: TrainingSection;
  slide: TrainingSlide | null; // null for the virtual intro slide
}

export function flattenCourse(): FlatSlideRef[] {
  const out: FlatSlideRef[] = [];
  COURSE_SECTIONS.forEach((section, sectionIdx) => {
    out.push({ sectionIdx, slideIdx: 0, slideId: `${section.id}-__intro`, section, slide: null });
    section.slides.forEach((slide, i) => {
      out.push({ sectionIdx, slideIdx: i + 1, slideId: slide.id, section, slide });
    });
  });
  return out;
}

export const TOTAL_SLIDES = flattenCourse().length;
export const TOTAL_MINUTES = COURSE_SECTIONS.reduce((sum, s) => sum + s.minutes, 0);

export function sectionById(id: string): TrainingSection | undefined {
  return COURSE_SECTIONS.find((s) => s.id === id);
}

export function sectionIndexById(id: string): number {
  return COURSE_SECTIONS.findIndex((s) => s.id === id);
}
